/*
 * 接口统一集成模块
 */
import * as login from './moudules/login'
import * as user from './moudules/user'
import * as dept from './moudules/dept'
import * as role from './moudules/role'
import * as menu from './moudules/menu'
import * as customer from './moudules/customer'
import * as memberFollow from './moudules/memberFollow'
import * as rebateOrder from './moudules/rebateOrder'
import * as sourceSubject from './moudules/sourceSubject'
import * as sourceCategory from './moudules/sourceCategory'
import * as upload from './moudules/upload'
import * as platformSubject from './moudules/platformSubject'
import * as platformCategory from './moudules/platformCategory'
import * as platformActivity from './moudules/platformActivity'
import * as versionLog from './moudules/versionLog'
import * as usageGuide from './moudules/usageGuide'
import * as protocol from './moudules/protocol'
import * as feedback from './moudules/feedback'
import * as advertise from './moudules/advertise'
import * as syncRecord from './moudules/syncRecord'
import * as member from './moudules/member'
import * as platform from './moudules/platform'
import * as accessory from './moudules/accessory'
import * as finance from './moudules/finance'
import * as appletFunction from './moudules/function'
import * as commonRemark from './moudules/remark'

// 默认全部导出
export default {
    login,
    user,
    dept,
    role,
    menu,
    customer,
    memberFollow,
    rebateOrder,
    sourceSubject,
    sourceCategory,
    upload,
    platformSubject,
    platformCategory,
    platformActivity,
    versionLog,
    usageGuide,
    protocol,
    feedback,
    advertise,
    syncRecord,
    member,
    platform,
    accessory,
    finance,
    appletFunction,
    commonRemark

}



// WEBPACK FOOTER //
// ./src/http/api.js